<div class="add-data-error">
  <fw-alert severity="error" icon="warning-circle" variant="outlined"
    [title]="'projectImports.addDataDialog.importError.title' | translate">
    <p>{{'projectImports.addDataDialog.importError.message' | translate}} </p>
  </fw-alert>
  <div>
    <fw-form-heading [title]="'projectImports.addDataDialog.importError.errorDetails' | translate"></fw-form-heading>
    <div class="add-data-error-input-container">
      <div class="add-data-error-input">
        <fw-text-input [value]="errorMessage">
        </fw-text-input>
        <div class="add-data-error-input-overlay"></div>
      </div>
      <fw-button variant="outline" [cdkCopyToClipboard]="errorMessage" leftIcon="copy-item"
        test-id="cancel">{{ 'common.actions.copyToClipboard' | translate }}</fw-button>
    </div>
  </div>
</div>
